module.exports = __webpack_public_path__ + "static/media/elife-coins-tier3.4bd3e700.png";